import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';

export const VisitGeneralDetails = ({ visitDetails }) => {
  const { t } = useTranslation();

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  if (!visitDetails) return null;

  return (
    <Card>
      <CardHeader>
        <Heading variant="userAccountDetailsTitle">
          {t('userAccount.visitTab.visitInfo')}
        </Heading>
      </CardHeader>

      <CardContent className="space-y-2">
        <div>
          <span>{t('userAccount.visitTab.service')} </span>
          <span>{visitDetails.visitTitle?.toUpperCase()}</span>
        </div>

        {visitDetails.doctorName &&
          visitDetails.doctorSpeciality &&
          visitDetails.doctorSurname && (
            <div>
              <span>{t('userAccount.registrationsTab.doctor')} </span>
              <span>
                {visitDetails.doctorSpeciality.toUpperCase()} -{' '}
                {visitDetails.doctorName.toUpperCase()}{' '}
                {visitDetails.doctorSurname.toUpperCase()}
              </span>
            </div>
          )}

        <div>
          <span>{t('userAccount.visitTab.medicalCenter')} </span>
          <span>
            {visitDetails.department} {visitDetails.departmentAddress}
          </span>
        </div>

        <div>
          <span>{t('userAccount.visitTab.date')} </span>
          <span>{formatDateWithoutConversion(visitDetails.date)}</span>
        </div>

        <div>
          <span>Būsena: </span>
          <span>{visitDetails.statusDisplay}</span>
        </div>
      </CardContent>

      <CardFooter />
    </Card>
  );
};